import React, { useMemo } from "react";
import DataTable from "../../_Components/DataTable";
import _ from "lodash";
import { tools } from "../../../../core/utils/tools";
function DataGridAmusementServices({ data }) {
  const columns = useMemo(
    () => [
      // {
      //   accessor: "noRow",
      //   Header: "ردیف",
      //   minWidth: 100,
      // },
      {
        accessor: "completionDate",
        Header: "تاریخ",
        minWidth: 100,
      },
      {
        accessor: "completionTime",
        Header: "ساعت",
        minWidth: 100,
      },
      {
        accessor: "basketItemPersonId",
        Header: "بلیط",
        minWidth: 100,
      },
      {
        accessor: "e",
        Header: "شرح",
        minWidth: 200,
        Cell: ({ row }) => {
          return (
            <div>
              {row.original.type === 8
                ? row.original.description
                : row.original.type === 7
                  ? "شارژ کیف پول "
                  : `${row.original.basketItemAmusementServiceName} - ${row.original.basketItemAmusementServiceReserveItemGroupTitle} - ${row.original.basketItemAmusementServiceReserveItemTitle}`}
            </div>
          );
        },
      },
      {
        accessor: "promoCode",
        Header: "کدتخفیف",
        minWidth: 100,
      },
      {
        Header: "بدهکار",
        minWidth: 100,
        Cell: ({ row }) => {
          return (
            <div>
              {row.original.balanceType === 2
                ? tools.formatPriceNumber(row.original.amount)
                : "-"}
            </div>
          );
        },
      },
      {
        Header: "بستانکار",
        minWidth: 100,
        Cell: ({ row }) => {
          return (
            <div>
              {row.original.balanceType === 1
                ? tools.formatPriceNumber(row.original.amount)
                : "-"}
            </div>
          );
        },
      },
      {
        Header: "مانده",
        minWidth: 100,
        Cell: ({ row }) => {
          return (
            <div>{tools.formatPriceNumber(row.original.riallBalance)}</div>
          );
        },
      },
    ],
    []
  );

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGridAmusementServices;
